export const FORM_VIEW = {
  OTP_VIEW: 'OTP_VIEW',
  PHONE_VIEW: 'PHONE_VIEW',
  CREATE_DESK_VIEW: 'CREATE_DESK_VIEW',
}
